import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Button, IconButton, Box, Menu, MenuItem } from '@mui/material';
import { CustomThemeProvider } from '../theme';
import MenuIcon from '@mui/icons-material/Menu';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import UserIdentity from './UserIdentity';

function TopBar({ userData, handleLogout, onAddEventClick }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [legalAnchorEl, setLegalAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const legalOpen = Boolean(legalAnchorEl);
  const navigate = useNavigate();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setLegalAnchorEl(null);
  };

  const handleLegalMenuToggle = (event) => {
    event.stopPropagation();
    if (legalAnchorEl) {
      setLegalAnchorEl(null);
    } else {
      setLegalAnchorEl(event.currentTarget);
    }
  };

  const handleLegalMenuClose = () => {
    setLegalAnchorEl(null);
  };

  const handleLegalItemClick = (path) => {
    setLegalAnchorEl(null);
    handleClose();
    navigate(path);
  };

  return (
    <AppBar position="static" style={{ backgroundColor: '#0B1016' }}>
      <CustomThemeProvider>
        <Toolbar disableGutters sx={{ px: { xs: 2, sm: 3 } }}>
          <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
            <Box
              sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 1 }}
              onClick={() => navigate('/dashboard')}
            >
              <Box
                component="img"
                src="/FireSales1.png"
                alt="Clearance Scouts"
                sx={{
                  height: 40,
                  width: 40,
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                  objectFit: 'contain'
                }}
              />
            </Box>

            {userData && (
              <Box display="flex" alignItems="center" gap={1.5}>
                <Button
                  onClick={onAddEventClick}
                  startIcon={<CameraAltIcon />}
                  sx={{
                    mr: 1,
                    backgroundColor: '#331B65',
                    color: 'white',
                    borderRadius: '20px',
                    px: 2.5,
                    py: 0.5,
                    textTransform: 'none',
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    '&:hover': {
                      backgroundColor: '#2A1C50',
                      transform: 'scale(1.05)'
                    },
                    transition: 'all 0.2s'
                  }}
                >
                  Share
                </Button>

                <Box
                  display="flex"
                  alignItems="center"
                  sx={{
                    px: 1,
                    pr: 1.9,
                    py: 0.5,
                    borderRadius: '20px',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.15)' },
                    transition: 'background-color 0.2s'
                  }}
                >
                  <UserIdentity user={userData} size="md" variant="dark" />
                </Box>

                <IconButton
                  edge="end"
                  aria-label="account menu"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                  sx={{ ml: 0.5 }}
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  open={open}
                  onClose={handleClose}
                  sx={{ zIndex: 10005 }}
                  MenuListProps={{ sx: { zIndex: 10005 } }}
                  PaperProps={{ sx: { zIndex: 10005 } }}
                >
                  <MenuItem onClick={() => { handleClose(); navigate('/account'); }}>
                    Account
                  </MenuItem>
                  <MenuItem
                    onClick={handleLegalMenuToggle}
                    sx={{ '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.08)' } }}
                  >
                    Legal
                    <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
                      <ArrowForwardIcon
                        sx={{
                          fontSize: '1rem',
                          transform: legalOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                          transition: 'transform 0.2s'
                        }}
                      />
                    </Box>
                  </MenuItem>
                  <Menu
                    anchorEl={legalAnchorEl}
                    open={legalOpen}
                    onClose={handleLegalMenuClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    sx={{ zIndex: 10006 }}
                    MenuListProps={{ sx: { zIndex: 10006 } }}
                    PaperProps={{ sx: { zIndex: 10006, ml: 0.5 } }}
                  >
                    <MenuItem onClick={() => handleLegalItemClick('/about')}>About</MenuItem>
                    <MenuItem onClick={() => handleLegalItemClick('/terms')}>Terms of Service</MenuItem>
                    <MenuItem onClick={() => handleLegalItemClick('/privacy')}>Privacy Policy</MenuItem>
                  </Menu>
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Menu>
              </Box>
            )}
          </Box>
        </Toolbar>
      </CustomThemeProvider>
    </AppBar>
  );
}

export default TopBar;

